export default "__VITE_ASSET__BWvMmLbe__"